import { render, staticRenderFns } from "./DeleteBlackList.vue?vue&type=template&id=6c32eac7&scoped=true"
import script from "./DeleteBlackList.vue?vue&type=script&lang=js"
export * from "./DeleteBlackList.vue?vue&type=script&lang=js"
import style0 from "./DeleteBlackList.vue?vue&type=style&index=0&id=6c32eac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32eac7",
  null
  
)

export default component.exports